import React, { useEffect, useRef, useState } from "react";
import { useLocation, useNavigationType } from "react-router-dom";

// Helper function to get scroll position from the target container
const getScrollPosition = () => {
  const container = document.getElementById("main-container");
  if (container) {
    return container.scrollTop;
  }
  return (
    window.pageYOffset ||
    document.documentElement.scrollTop ||
    document.body.scrollTop ||
    0
  );
};

const ScrollRestoration = () => {
  const location = useLocation();
  const navigationType = useNavigationType(); // "PUSH", "POP", or "REPLACE"
  const [isLoading, setIsLoading] = useState(false);
  const prevLocationRef = useRef(location);
  const lastScrollPositionRef = useRef(0);

  // Disable native scroll restoration so our code has full control.
  useEffect(() => {
    window.history.scrollRestoration = "manual";
  }, []);

  // Global scroll listener to update the latest scroll position.
  useEffect(() => {
    const handleScroll = () => {
      lastScrollPositionRef.current = getScrollPosition();
    };

    window.addEventListener("scroll", handleScroll);
    const container = document.getElementById("main-container");
    if (container) {
      container.addEventListener("scroll", handleScroll);
    }

    return () => {
      window.removeEventListener("scroll", handleScroll);
      if (container) {
        container.removeEventListener("scroll", handleScroll);
      }
    };
  }, []);

  // Save scroll position on forward navigations (PUSH).
  useEffect(() => {
    if (navigationType === "PUSH") {
      const prevKey = prevLocationRef.current.pathname;
      sessionStorage.setItem(
        prevKey,
        JSON.stringify(lastScrollPositionRef.current),
      );
    }
    prevLocationRef.current = location;
  }, [location, navigationType]);

  // Restore scroll position on back (POP) navigation.
  useEffect(() => {
    if (navigationType === "POP") {
      const key = location.pathname;
      const saved = sessionStorage.getItem(key);
      const pos = saved ? JSON.parse(saved) : 0;
      // Show our loading overlay while waiting for restoration.
      setIsLoading(true);

      // Delay restoration to allow layout to settle.
      setTimeout(() => {
        const container = document.getElementById("main-container");
        if (container) {
          container.scrollTo(0, pos);
        } else {
          window.scrollTo(0, pos);
        }
        // Hide the loading overlay after restoration.
        setIsLoading(false);
      }, 800);
    }
  }, [location, navigationType]);

  return (
    <>
      {isLoading && (
        <div
          style={{
            position: "fixed",
            top: 0,
            left: 0,
            width: "100%",
            height: "100%",
            backgroundColor: "white",
            zIndex: 9999,
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
          }}
        >
          <div>Loading...</div>
        </div>
      )}
    </>
  );
};

export default ScrollRestoration;
